import { render, staticRenderFns } from "./CommonPagination.vue?vue&type=template&id=49c48102&scoped=true"
import script from "./CommonPagination.vue?vue&type=script&lang=js"
export * from "./CommonPagination.vue?vue&type=script&lang=js"
import style0 from "./CommonPagination.vue?vue&type=style&index=0&id=49c48102&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c48102",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49c48102')) {
      api.createRecord('49c48102', component.options)
    } else {
      api.reload('49c48102', component.options)
    }
    module.hot.accept("./CommonPagination.vue?vue&type=template&id=49c48102&scoped=true", function () {
      api.rerender('49c48102', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/CommonPagination.vue"
export default component.exports